import { signUserFunction } from './gallery-properties.flow'
import { keys, assign, omitBy } from 'lodash-es'
import { isEmpty, safeGet, safePick, defaultTo } from '../utils/bits'

import DEFAULT_MESSAGE_BUNDLE from '../../locales/en'

export default signUserFunction(calcCompleteMessageBundle)

function calcCompleteMessageBundle(rawVal, calcProp) {
  const locale = calcProp('locale')
  const all_message_bundles = calcProp('all_message_bundles')
  const message_bundle_overrides = calcProp('message_bundle_overrides')
  const complete_message_bundle = defaultTo(rawVal, DEFAULT_MESSAGE_BUNDLE)

  const bundle = defaultTo(safeGet(all_message_bundles, locale), complete_message_bundle)
  const mbKeys = keys(bundle)
  const mbLocal = omitBy(safePick(safeGet(message_bundle_overrides, locale), mbKeys), isEmpty)
  const mbGlobal = omitBy(safePick(message_bundle_overrides, mbKeys), isEmpty)
  const toReturn = assign({}, bundle, mbLocal, mbGlobal)

  return toReturn
}
